module.exports = __webpack_public_path__ + "img/cancelled-order.ffcd6f95.svg";